/**
 * How long to wait before polling again, for a case-level response still being computed
 * (`status: 'calculating'`): the interval it names, else 5 s. False (stop polling) for a ready
 * one, or once the last poll failed: a failed poll keeps the last 'calculating' body as its data,
 * so without the status check a 503 would be retried every interval; the user's Retry is the way
 * back. Shared by the eval page's and the case page's polled reads.
 *
 * @param {object | undefined} data - The latest successful response, if any.
 * @param {string} status - The query's status ('error' once the last fetch failed).
 * @return {number | false} The poll interval in ms, or false.
 */
export function calculatingInterval(
  data: { status?: string; pollIntervalMs?: number | null } | undefined,
  status: string
): number | false {
  if (status === 'error' || data?.status !== 'calculating') return false;

  return data.pollIntervalMs ?? 5_000;
}
